module.exports = __webpack_public_path__ + "static/img/Group21706.2a83e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Group21706.png
// module id = 8R0y
// module chunks = 134